import { validateTextWithHypen } from '@/utils';
export default class ShareInfoConfig {
    _hubId;
    _shareDelaySecond;
    /** 허브 수수료 */
    _feeRate;
    _workerFeeRate;
    _storeFeeRate;
    /** 상점 관리비 수수료 */
    _storeManagementFeeRate;
    /** 접수 목록 공유 여부 */
    _isDisplayedOnOrder;
    /** 허브 전체 공유 유무
     *  해당 값이 true일 경우, 발주허브, 수주허브의 전체상점이 양방향 공유로 설정됨 (발주허브 ↔ 수주허브)
     */
    _isMutualShared;
    _stores;
    constructor({ hubId, shareDelaySecond, feeRate, workerFeeRate, storeFeeRate, storeManagementFeeRate, isDisplayedOnOrder, isMutualShared, stores, }) {
        this._hubId = hubId;
        this._shareDelaySecond = shareDelaySecond;
        this._feeRate = feeRate;
        this._workerFeeRate = workerFeeRate;
        this._storeFeeRate = storeFeeRate;
        this._storeManagementFeeRate = storeManagementFeeRate;
        this._isDisplayedOnOrder = isDisplayedOnOrder;
        this._isMutualShared = isMutualShared;
        this._stores = stores;
    }
    get isMutualShared() {
        return this._isMutualShared;
    }
    get hubId() {
        return this._hubId;
    }
    set hubId(value) {
        this._hubId = value;
    }
    get shareDelaySecond() {
        return this._shareDelaySecond;
    }
    get feeRate() {
        return this._feeRate;
    }
    get workerFeeRate() {
        return this._workerFeeRate;
    }
    get storeFeeRate() {
        return this._storeFeeRate;
    }
    get storeManagementFeeRate() {
        return this._storeManagementFeeRate;
    }
    get isDisplayedOnOrder() {
        return this._isDisplayedOnOrder;
    }
    get formattedStores() {
        return this._stores.map(({ storeId, storeName, }) => ({
            storeId: validateTextWithHypen(storeId),
            storeName: validateTextWithHypen(storeName),
        }));
    }
}
